/**
 * Human Resource Simulator - Core Type Definitions
 * 国家人材育成シミュレーター 型定義
 */
// ============================================
// Simulation Constants (Magic Numbers Extracted)
// ============================================
export const SIMULATION_CONSTANTS = {
    /** CES関数の弾力性パラメータ (α < 1 で補完性を表現) */
    CES_EXPONENT: 0.8,
    /** キーパーソンの上位パーセンタイル (95%タイル = 1.645σ) */
    KEY_PERSON_Z_SCORE: 1.645,
    /** キーパーソンの人口比率 (上位5%) */
    KEY_PERSON_RATIO: 0.05,
    /** 総合スコアの平均重み */
    SCORE_AVG_WEIGHT: 0.6,
    /** 総合スコアの最小値重み (弱点ペナルティ) */
    SCORE_MIN_WEIGHT: 0.4,
    /** デジタル/AI軸の減衰率 (技術陳腐化が速い) */
    DIGITAL_AI_DECAY: 1.5,
    /** 標準的な減衰率 */
    STANDARD_DECAY: 0.3,
    /** 年齢効率の最小値 */
    AGE_EFFICIENCY_MIN: 0.3,
    /** 年齢効率の基準年齢 */
    AGE_EFFICIENCY_BASE_AGE: 22,
    /** 年齢効率の減衰範囲 */
    AGE_EFFICIENCY_RANGE: 60,
    /** 偏差値計算の基準値 */
    DEVIATION_BASE: 50,
    /** 偏差値計算のスケール */
    DEVIATION_SCALE: 10,
};
// ============================================
// Capability Axes (12次元能力ベクトル)
// ============================================
export const CAPABILITY_AXIS_KEYS = [
    'basicScience',
    'appliedTech',
    'digitalAI',
    'manufacturing',
    'finance',
    'energy',
    'globalCompete',
    'innovation',
    'education',
    'policyMaking',
    'implementation',
    'succession',
];
export const CAPABILITY_AXES = [
    { key: 'basicScience', name: '基礎科学', nameEn: 'Basic Science', color: '#8884d8', description: '基礎研究・理論的知識' },
    { key: 'appliedTech', name: '応用技術', nameEn: 'Applied Technology', color: '#82ca9d', description: '実用的技術実装能力' },
    { key: 'digitalAI', name: 'デジタル・AI', nameEn: 'Digital/AI', color: '#ffc658', description: '先端コンピューティング・AI能力' },
    { key: 'manufacturing', name: '製造・ものづくり', nameEn: 'Manufacturing', color: '#ff7300', description: '生産・製造技術' },
    { key: 'finance', name: '金融・経済', nameEn: 'Finance/Economics', color: '#00C49F', description: '金融・経済専門知識' },
    { key: 'energy', name: 'エネルギー・環境', nameEn: 'Energy/Environment', color: '#FF8042', description: 'サステナビリティ・エネルギー知識' },
    { key: 'globalCompete', name: '国際競争力', nameEn: 'Global Competitiveness', color: '#0088FE', description: 'グローバル市場でのポジショニング能力' },
    { key: 'innovation', name: 'イノベーション', nameEn: 'Innovation', color: '#00C49F', description: '創造的問題解決・ブレークスルー思考' },
    { key: 'education', name: '教育基盤', nameEn: 'Education Foundation', color: '#FFBB28', description: '次世代育成能力' },
    { key: 'policyMaking', name: '政策立案', nameEn: 'Policy Making', color: '#FF8042', description: '政府政策策定能力' },
    { key: 'implementation', name: '社会実装力', nameEn: 'Social Implementation', color: '#8884d8', description: '実社会での展開・適用能力' },
    { key: 'succession', name: '技術継承', nameEn: 'Technical Succession', color: '#82ca9d', description: '知識・技術の世代間移転' },
];
// ============================================
// Sectors (4セクター)
// ============================================
export const SECTOR_KEYS = ['university', 'industry', 'government', 'research'];
export const SECTORS = [
    {
        key: 'university',
        name: '大学',
        nameEn: 'University',
        icon: '🎓',
        color: '#8b5cf6',
        growthAxes: ['basicScience', 'education', 'innovation'],
        growthMultiplier: 2.5,
    },
    {
        key: 'industry',
        name: '産業界',
        nameEn: 'Industry',
        icon: '🏭',
        color: '#10b981',
        growthAxes: ['appliedTech', 'manufacturing', 'digitalAI', 'implementation'],
        growthMultiplier: 3.0,
    },
    {
        key: 'government',
        name: '政府',
        nameEn: 'Government',
        icon: '🏛️',
        color: '#f59e0b',
        growthAxes: ['policyMaking', 'globalCompete'],
        growthMultiplier: 2.0,
    },
    {
        key: 'research',
        name: '研究機関',
        nameEn: 'Research Institute',
        icon: '🔬',
        color: '#3b82f6',
        growthAxes: ['basicScience', 'appliedTech', 'innovation', 'globalCompete'],
        growthMultiplier: 2.8,
    },
];
export const DEFAULT_POLICY_PARAMS = {
    masterEnrollment: 12,
    phdEnrollment: 10,
    phdToAcademia: 18,
    populationDeclineRate: 1.2,
    retirementAgeExtension: 0,
};
export const DEFAULT_INVESTMENTS = {
    university: 30,
    industry: 35,
    government: 15,
    research: 20,
};
//# sourceMappingURL=index.js.map